module.exports = __webpack_public_path__ + "img/ms.fc9a6a27.jpg";